import { ROUTE_PATH, OperationType } from "common/constants/sm-constants";
import { WidgetModel } from "common/models/utility-models/base-model";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class AssignmentDetailsMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Student Details',
            "",
            null,
            false,
            false,
            8,
            true,
            false,
            [],
            false,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            false,
            null,
            null,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: false },
            null,
            null,
            {
                isPreview: false,
                isPreviewType: '',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            false,
            false,
            true,
            [],
            false,
            { isExtraActions: false, btnLabel: '' },
            {isCheckboxEmit: false,
                emitKey: 'id',
                checkedKey: '',
                valueKey: '',
            },
            {
                isDownload: true,
                key: 'docpath',
                valueKey: 'docpath',
              },
              

        );
    }


    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const topic = new Headers('Topic', 'assignment_name', true, true, 'text', '0', { isColumnNavigation: true, navigationUrl: ROUTE_PATH.assignment_details, navigateOperationType: OperationType.UPDATE, navigateTransferData: new WidgetModel() });
        const dateAndTime = new Headers('Date And Time', 'start_date', false, true, 'text');
        const type = new Headers('Type ', 'type_name', true, true, 'text');
        const uploaded = new Headers('Uploaded Yes/No ', 'uploadFlag', true, true, 'text');
        const uploadedFile = new Headers('Uploaded File', 'display_filename', false, true, 'text');
        const attendance = new Headers('Attendance', 'attended_flag', false, true, 'text', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: {}
        }, null, { isToggle: false, toggleKey: 'attended_flag', toggleCheckedValue: 1, toggleUncheckedValue: 0 });
         

        headers.push(topic);
        headers.push(dateAndTime);
        headers.push(type);
        headers.push(uploaded);
        headers.push(uploadedFile);
        headers.push(attendance);
        return headers;
    }
}